<template>
    <data-view :tableColumns="tableColumns" :tableData="items" :actionButtons="actionButtons" titleKey="documentName"
        @sortChanged="event => emit('sortChanged', event)"
        @loadMore="emit('loadMore')">
        <template #col-send="{ row }">
            <span :class="['f-bold',row.send == 1 ? 'custom-success' : 'custom-danger']"> {{ row.send == 1 ? $t('yes') : $t('no')  | capitalize }} </span>
        </template>
    </data-view>
</template>

<script setup>
import { ref } from 'vue'
import DataView from '@/views/app/components/DataView'
const emit = defineEmits(['sortChanged', 'loadMore'])

const props = defineProps({
    items: { type: Array, default: () => ([]) }
})

const tableColumns = ref([
    { key: 'vendorName', label: 'vendor', sortable: false },
    { key: 'email', label: 'email', sortable: false },
    { key: 'send', label: 'sent', sortable: false },
    { key: 'subject', label: 'subject', sortable: false }
])

const actionButtons = ref([])


</script>
